import once from 'transmute/once';
import events from 'conversations-inbox-ui/events.yaml'; // eslint-disable-line
import { buildTrackerCallbacks, createTrackEvent, createAsyncTracker, createStandaloneTrackEvent, createStandaloneAsyncTracker } from 'svh-workspace-ui-lib/usage-tracking/public/clients';
const CONVERSATIONS_TRACKING_NAMESPACE = 'Conversations';
const platform = 'desktop-app';
const {
  onError
} = buildTrackerCallbacks();
const defaultProperties = {
  channel: undefined,
  namespace: 'conversations',
  platform,
  screen: 'Inbox',
  subscreen: 'unknown'
};
export const getUsageTracker = once(() => createAsyncTracker({
  events,
  properties: defaultProperties,
  onError
}));
export const getStandaloneUsageTracker = once(() => createStandaloneAsyncTracker({
  config: {
    onError,
    properties: defaultProperties,
    standalone: true
  },
  namespace: CONVERSATIONS_TRACKING_NAMESPACE
}));
export const getBeaconUsageTracker = once(() => createAsyncTracker({
  events,
  properties: defaultProperties,
  onError
}));
export const trackEvent = createTrackEvent(getUsageTracker);
export const getStandaloneTrackEvent = createStandaloneTrackEvent(getStandaloneUsageTracker);
const beforeUnloadTracker = createTrackEvent(getBeaconUsageTracker);
export const trackEventBeforeUnload = event => {
  beforeUnloadTracker(event, 'trackEventBeforeUnload');
};